enum MediaHlsVideoSegmentFormat {
  /** Video packed in ISO BMFF CMAF Fragmented MP4. Support AVC and HEVC. */
  FMP4 = 'FMP4',

  /** MPEG-2 transport stream. Support AVC. */
  MPEG2_TS = 'MPEG2-TS',
}

export default MediaHlsVideoSegmentFormat
